import { render, staticRenderFns } from "./ImportIngresarCodigos.vue?vue&type=template&id=0a55d9f3&scoped=true"
import script from "./ImportIngresarCodigos.vue?vue&type=script&lang=js"
export * from "./ImportIngresarCodigos.vue?vue&type=script&lang=js"
import style0 from "./ImportIngresarCodigos.vue?vue&type=style&index=0&id=0a55d9f3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a55d9f3",
  null
  
)

export default component.exports